/**
 * Waits for every request — even after one has failed — then rethrows the first failure (in
 * request order). Lets a batch refresh its listings once, when nothing is still in flight.
 */
export async function settleAll(requests: Promise<unknown>[]): Promise<void> {
    const results = await Promise.allSettled(requests);
    const failure = results.find((result): result is PromiseRejectedResult => result.status === 'rejected');
    if (failure) throw failure.reason;
}
